exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".single-pro-tab li{height:80px;float:left}.thumbail---dmk_3{max-height:78px}", ""]);

// exports
exports.locals = {
	"thumbail": "thumbail---dmk_3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/views/app.detail/style.scss
// module id = 365
// module chunks = 0